//redirect için provider

import React, { createContext, useContext, useEffect, ReactNode } from 'react'
import { useAuth } from './Auth'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'

interface RedirectContextType {}

const RedirectContext = createContext<RedirectContextType>({})

export const useRedirect = () => {
  return useContext(RedirectContext)
}

interface RedirectProviderProps {
  children: ReactNode
}

export const RedirectProvider: React.FC<RedirectProviderProps> = ({
  children,
}) => {
  const { user, isLoading, isActive } = useAuth()

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (isLoading) return

    if (location.pathname === '/no-subscription' && isActive)
      navigate('/dashboard')

    if (!isActive && user) navigate('/no-subscription')

    if (!user) navigate('/login')

    if (user && location.pathname === '/login') navigate('/dashboard')
  }, [user, isLoading, navigate])

  const contextValue: RedirectContextType = {}

  if (isLoading) {
    return (
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          bgcolor: 'background.default',
        }}
      >
        <CircularProgress size={60} color="primary" />
      </Box>
    )
  }

  return (
    <RedirectContext.Provider value={contextValue}>
      {children}
    </RedirectContext.Provider>
  )
}
